import styled from "@emotion/styled";
import { FC } from "react";
import { Link } from "react-router-dom";
import logo from "../assets/logo_centre films_schwarz.webp";

const Header = styled("header")(() => ({
  width: "100%",
  height: 80,
  display: "flex",
  flexDirection: "row",
  flexWrap: "nowrap",
  alignItems: "center",
  backgroundColor: "#fff",
  position: "fixed",
  top: 0,
  left: 0,
  paddingLeft: "1rem",
  paddingRight: "1rem",
}));

const Nav = styled("nav")(() => ({
  display: "flex",
  flexDirection: "row",
  flexGrow: 1,
  flexWrap: "nowrap",
  justifyContent: "flex-end",
  alignItems: "center",
  gap: "1rem",
}));

const Logo = styled("img")(() => ({
  width: 50,
  height: 50,
}));

const Placeholder = styled("div")(() => ({
  width: "100%",
  height: 80,
}));

const NavLink = styled(Link)(() => ({
  textDecoration: "none",
  color: "#000",
  fontSize: "1rem",
}));

const PageNav: FC = () => {
  return (
    <>
      <Header>
        <Link to={"/"}>
          <Logo loading={"lazy"} src={logo} alt={"cf logo"} />
        </Link>
        <Nav>
          <NavLink to={"/"}>Home</NavLink>
          <NavLink to={"/impressum"}>Impressum</NavLink>
          <NavLink to={"/datenschutz"}>Datenschutz</NavLink>
        </Nav>
      </Header>
      <Placeholder />
    </>
  );
};

export default PageNav;
